type ThemeColors =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'warn'
  | 'info'
  | 'success'
  | 'error';

export class RadioNode {
  id!: string;
  label!: string;
  onChange?: (id: string, node: RadioNode) => void;
  color?: ThemeColors;
  order?: number;
  parent?: string;

  constructor(props: Partial<RadioNode>) {
    Object.assign(this, props);
  }
}
